import { fromJS, Map, Record } from 'immutable';
import { startsWith } from 'lodash';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { BannerCanvasTypesEnum } from '../features-data.data';
import { CanvasConfig } from './canvas-config.model';

export const CANVAS_SCHEMA = Object.freeze({
  CANVAS_CONFIG: CanvasConfig,
  NAME: '',
  PLAN_ID: '',
  TYPE: '',
  TRACKING: Map({}),
});

const RECORD = generateSchema(CANVAS_SCHEMA);
const KEYS: any = generateKeys(CANVAS_SCHEMA);

export class Canvas extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.CANVAS_CONFIG,
        value: new CanvasConfig(this.canvasConfig),
      },
    ]);

    return selfModel as Canvas;
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get planId(): string {
    return this.get(KEYS.PLAN_ID);
  }

  get canvasConfig(): CanvasConfig {
    return this.get(KEYS.CANVAS_CONFIG);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get tracking(): Map<string, any> {
    return this.get(KEYS.TRACKING) || Map({});
  }

  isFeatureLockCanvas(): boolean {
    return startsWith(this.name, BannerCanvasTypesEnum.feature_lock);
  }

  isFeatureHighlightCanvas(): boolean {
    return startsWith(this.name, BannerCanvasTypesEnum.feature_highlight);
  }

  isQuotaReachedCanvas(): boolean {
    return startsWith(this.name, BannerCanvasTypesEnum.quota_reached);
  }

  isWindowCanvas(): boolean {
    return startsWith(this.name, BannerCanvasTypesEnum.window);
  }
}
